import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";

import { Button, Flex, Box } from "@chakra-ui/react";

import { Form, Formik } from "formik";
import { FocusError } from "../../../components/FocusError";
import { ProfissionalizacaoCadastrar } from "./Cadastrar";
import { VisualizarPageProfissionalizacao } from "./Visualizar";
import * as Yup from "yup";
import Swal from "sweetalert2";
import CriancaService from "../../../../main/services/CriancaService";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../utils/hasFormChanged";

import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { scrollToFieldAnexo } from "../../../utils/scrollToFIeldAnexo";
import { Permission, criancaFunc } from "../../../../helpers/Funcionalidades";

const suportedFormats = [
  ".png",
  ".bmp",
  ".tiff",
  ".jpg",
  ".jpeg",
  ".doc",
  ".docx",
  ".txt",
  ".dot",
  ".pdf",
  ".xml",
  ".xls",
  ".xlam",
  ".ods",
];

const schema = Yup.object().shape({
  cursoProfissionalizante: Yup.string().required("Este campo é obrigatório!"),
  trabalho: Yup.string().required("Este campo é obrigatório!"),
  estagio: Yup.string().required("Este campo é obrigatório!"),
  jovemAprendiz: Yup.string().required("Este campo é obrigatório!"),
  curriculoVitae: Yup.string().required("Este campo é obrigatório!"),
  nomeEmpresa: Yup.string().when("jovemAprendiz", {
    is: "S",
    then: Yup.string().trim().required("Este campo é obrigatório!"),
    otherwise: Yup.string().nullable(),
  }),

  anexoCurriculo: Yup.mixed()
    .when(["curriculoVitae", "originalAnexoCurriculo"], {
      is: (curriculoVitae, originalAnexoCurriculo) => {
        return curriculoVitae === "S" && !originalAnexoCurriculo;
      },
      then: Yup.mixed().nullable().required("Este campo é obrigatório!"),
    })
    .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
      if (value === null) {
        return true;
      } else {
        return value.size <= 10000000;
      }
    })
    .test("fileType", "Anexar uma extensão válida.", (value) => {
      if (value && value.path) {
        let haveFormat = false;
        suportedFormats.forEach((format) => {
          if (value.path.toString().toLowerCase().includes(format)) {
            haveFormat = true;
          }
        });
        return haveFormat;
      } else {
        return true;
      }
    }),

  anexoCursoProfissionalizante: Yup.mixed()
    .when(["cursoProfissionalizante", "originalCursoProfissionalizante"], {
      is: (curriculoVitae, originalAnexoCurriculo) => {
        return curriculoVitae === "S" && !originalAnexoCurriculo;
      },
      then: Yup.mixed().nullable().required("Este campo é obrigatório!"),
    })
    .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
      if (value === null) {
        return true;
      } else {
        return value.size <= 10000000;
      }
    })
    .test("fileType", "Anexar uma extensão válida.", (value) => {
      if (value && value.path) {
        let haveFormat = false;
        suportedFormats.forEach((format) => {
          if (value.path.toString().toLowerCase().includes(format)) {
            haveFormat = true;
          }
        });
        return haveFormat;
      } else {
        return true;
      }
    }),

  anexoProgramaJovemAprendiz: Yup.mixed()
    .when(["jovemAprendiz", "originalAnexoJovemAprendiz"], {
      is: (curriculoVitae, originalAnexoCurriculo) => {
        return curriculoVitae === "S" && !originalAnexoCurriculo;
      },
      then: Yup.mixed().nullable().required("Este campo é obrigatório!"),
    })
    .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
      if (value === null) {
        return true;
      } else {
        return value.size <= 10000000;
      }
    })
    .test("fileType", "Anexar uma extensão válida.", (value) => {
      if (value && value.path) {
        let haveFormat = false;
        suportedFormats.forEach((format) => {
          if (value.path.toString().toLowerCase().includes(format)) {
            haveFormat = true;
          }
        });
        return haveFormat;
      } else {
        return true;
      }
    }),
});

export const VisualizarProfissionalizacao = () => {
  const { id } = useParams();
  const [isTrueVisualizar, setIsTrueVisualizar] = useState(true);

  const [anexoCurriculoEditado, setAnexoCurriculoEditado] = useState(false);
  const [anexoCursoProfEditado, setAnexoCursoProfEditado] = useState(false);
  const [anexoAprendizEditado, setAnexoAprendizEditado] = useState(false);

  // const [removeu, setRemoveu] = useState(false);
  // const [editarAnexo, setEditarAnexo] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();

  const history = useHistory();
  const url = window.location.href;
  const {
    atualizarProfissionalizacao,
    setAtualizarProfissionalizacao,
    cadastrarProfissionalizacao,
    setCadastrarProfissionalizacao,
    setEditarProfCrianca,
    setCadastrarProfCrianca,
    setEditarCriancaCr,
    radioClick,
    setRadioClick,
    idPJ,
  } = useAppContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia]
  );

  useEffect(() => {
    if (url.includes("visualizar")) {
      setIsTrueVisualizar(true);
      setRadioClick("");
    }
  }, [url, setEditarProfCrianca, setRadioClick]);

  useEffect(() => {
    if (url.includes("editar")) {
      setRadioClick("Editar");
    }
  }, [url, setRadioClick]);

  useEffect(() => {
    setEditarCriancaCr(false);
  }, [setEditarCriancaCr]);

  const [initialValues, setInitialValues] = useState({
    curriculoVitae: "",
    cursoProfissionalizante: "",
    jovemAprendiz: "",

    trabalho: "",
    estagio: "",
    nomeEmpresa: "",

    originalAnexoCurriculo: null,
    anexoCurriculo: null,

    originalCursoProfissionalizante: null,
    anexoCursoProfissionalizante: null,

    originalAnexoJovemAprendiz: null,
    anexoProgramaJovemAprendiz: null,
  });

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  useEffect(() => {
    if (cadastrarProfissionalizacao) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setCadastrarProfissionalizacao(false);
      });
    } else if (atualizarProfissionalizacao) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setAtualizarProfissionalizacao(false);
      });
    }
  }, [
    atualizarProfissionalizacao,
    setAtualizarProfissionalizacao,
    cadastrarProfissionalizacao,
    setCadastrarProfissionalizacao,
  ]);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        trabalho,
        estagio,
        nomeEmpresa,
        curriculoVitae,
        anexoCurriculo,
        cursoProfissionalizante,
        anexoCursoProfissionalizante,
        jovemAprendiz,
        anexoProgramaJovemAprendiz,
      } = values;

      const valuesToSend = {
        cursoProfissionalizante: cursoProfissionalizante,
        trabalho: trabalho,
        estagio: estagio,
        jovemAprendiz: jovemAprendiz,
        nomeEmpresa: jovemAprendiz === "S" ? nomeEmpresa : "",
        curriculoVitae: curriculoVitae,
      };

      if (anexoCurriculo) {
        if (curriculoVitae === "N") {
          valuesToSend["removerAnexoCurriculo"] = true;
        }
        valuesToSend["anexoCurriculo"] = anexoCurriculo;
      } else {
        valuesToSend["removerAnexoCurriculo"] =
          anexoCurriculoEditado || curriculoVitae === "N";
      }

      if (anexoCursoProfissionalizante) {
        if (cursoProfissionalizante === "N") {
          valuesToSend["removerAnexoCursoProfissionalizante"] = true;
        }
        valuesToSend["anexoCursoProfissionalizante"] =
          anexoCursoProfissionalizante;
      } else {
        valuesToSend["removerAnexoCursoProfissionalizante"] =
          anexoCursoProfEditado || cursoProfissionalizante === "N";
      }

      if (anexoProgramaJovemAprendiz) {
        if (jovemAprendiz === "N") {
          valuesToSend["removerAnexoProgramaJovemAprendiz"] = true;
        }
        valuesToSend["anexoProgramaJovemAprendiz"] = anexoProgramaJovemAprendiz;
      } else {
        valuesToSend["removerAnexoProgramaJovemAprendiz"] =
          anexoAprendizEditado || jovemAprendiz === "N";
      }

      console.log("\nValuesToSend: ", valuesToSend, "\n");

      if (isTrueVisualizar) {
        setRadioClick("Editar");
        setIsTrueVisualizar(!isTrueVisualizar);
        history.push(`/crianca/editar-profissionalizacao/${id}`);
      } else {
        if (radioClick === "Editar") {
          CriancaService.putProfissionalizacao(id, valuesToSend)
            .then((res) => {
              setRadioClick("");
              setIsTrueVisualizar(true);
              setCadastrarProfCrianca(false);
              setEditarProfCrianca(false);
              history.push(`/crianca/visualizar-profissionalizacao/${id}`);
              setEditarProfCrianca(false);
              setCadastrarProfCrianca(false);
              setAtualizarProfissionalizacao(true);
            })
            .catch((error) => {
              console.log(error.response?.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        } else {
          CriancaService.postProfissionalizacao(id, valuesToSend)
            .then((res) => {
              // const { id: idProfissionalizacao } = res.data;
              setRadioClick("");
              // if (possuiAnexoCurriculo === "S") {
              //   CriancaService.postCurriculoVitae(
              //     id,
              //     anexoCurriculo,
              //     idProfissionalizacao
              //   ).catch((error) => {
              //     console.error("Erro ao adicionar o currículo vitae:", error);
              //   });
              // }
              setIsTrueVisualizar(true);
              setCadastrarProfCrianca(false);
              setEditarProfCrianca(false);
              history.push(`/crianca/visualizar-profissionalizacao/${id}`);
              setCadastrarProfCrianca(false);
              setEditarProfCrianca(false);
              setCadastrarProfissionalizacao(true);
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
          console.log("\n\n\nELSE DO POST!");
        }
      }

      actions.setSubmitting(false);
    });
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(criancaFunc.visualizarProfissionalizacao) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    <>
      <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {(props) => (
              <Form onKeyDown={onKeyDown}>
                <FocusError />
                {url.includes("editar") &&
                  setEditarProfCrianca(
                    hasFormChanged(initialValues, props.values)
                  )}

                {isTrueVisualizar ? (
                  <VisualizarPageProfissionalizacao
                    id={id}
                    initialValues={initialValues}
                    setIsTrueVisualizar={setIsTrueVisualizar}
                    setInitialValues={setInitialValues}
                    url={url}
                  />
                ) : roleKeycloack &&
                  (roleKeycloack?.includes(
                    criancaFunc.cadastrarProfissionalizacao
                  ) ||
                    ((roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      )) &&
                      user?.orgaoExterno?.includes(idPJ))) ? (
                  <ProfissionalizacaoCadastrar
                    initialValues={initialValues}
                    idAnexo={idAnexo}
                    idtipoPendencia={idTipoPendencia}
                    scrollToField={scrollToField}
                    anexoCurriculoEditado={anexoCurriculoEditado}
                    setAnexoCurriculoEditado={setAnexoCurriculoEditado}
                    anexoCursoProfEditado={anexoCursoProfEditado}
                    setAnexoCursoProfEditado={setAnexoCursoProfEditado}
                    anexoAprendizEditado={anexoAprendizEditado}
                    setAnexoAprendizEditado={setAnexoAprendizEditado}
                  />
                ) : (
                  <Box mt={4}>
                    <SemRegistros buttonVisible={true} half />
                  </Box>
                )}
                <Flex justifyContent="flex-end">
                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={criancaFunc.editarProfissionalizacao}
                    user={user}
                    id={idPJ}
                    visualizar={true}
                  >
                    <Button
                      type="submit"
                      translate="no"
                      mt="30px"
                      px="45px"
                      h="42px"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      // isLoading={props.isSubmitting}
                    >
                      {isTrueVisualizar ? "Editar" : "Salvar"}
                    </Button>
                  </Permission>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
    </>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
